<template>
  <div class="block-footer">
    <div class="container">
      <div class="block-footer__logos">
        <img class="block-footer__avtomir" src="../images/logo/avtomir.svg" alt="Автомир" />
        <img class="block-footer__logo" src="../images/logo/logo.png" alt="Geely" />
      </div>
      <div>
        <div class="yur-info">
          <p>ООО «Автомир-Трейд» Москва</p>
          <p>Юр.адрес: 107497, город Москва, улица Иркутская, дом 5/6, строение 1, помещение 321</p>
          <p>Факт.адрес: г.Химки, Ленинградское ш., вл. 18, стр. 1</p>
          <p>ИНН: 7730569353</p>
          <p>ОГРН: 1077761079263</p>
        </div>
        <a :href="`tel:+${CONSTANTS.phone_raw}`">
          {{ CONSTANTS.phone }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";

export default {
  name: "block-footer",
  mixins: [Mixin],
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";
.block-footer {
  padding-top: 30px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: $primary-text;
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__logos {
    width: 100%;
    max-width: 290px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__logo {
    width: 140px;
  }

  &__avtomir {
    width: 140px;
  }
}

.yur-info {
  margin-top: 20px;
}
</style>